
import { throwError as observableThrowError, Observable, of, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { NotificationTransFormer } from '../../_transformers/notification.transformer';
import { map, delay, catchError, shareReplay } from 'rxjs/operators';

@Injectable()
export class NotificationService {

    private _notificationStatusService = new BehaviorSubject<any>({});
    notificationStatusSource$ = this._notificationStatusService.asObservable();

    private _enterMsgClearNotification = new BehaviorSubject<any>({});
    enterMsgClearNotification$ = this._enterMsgClearNotification.asObservable();

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        //  private _httpClient: HttpClient,
        private _httpClientHelper: HttpClientHelper,
        private _notificationTransFormer: NotificationTransFormer,
    ) {
    }

    changeNotificationStatus(value) {
        this._notificationStatusService.next(value);
    }

    notifyEnterMsg(value) {
        this._enterMsgClearNotification.next(value);
    }

    public getOtherNotifications(user): Observable<any[]> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('other-notifications', {
        });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((info: any) => {
                return info;
            }))
            .pipe(delay(200))
    }

    public getNotifications(user): Observable<any[]> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('notifications', {
        });
        return this
            ._httpClientHelper
            .get(apiURL).pipe(
                map((info: any) => {
                    return info.map(
                        n => {
                            return this._notificationTransFormer.transform(n);
                        }
                    );
                }))
            .pipe(delay(200))
    }

    public markAllNotificationsAsRead(user): Observable<any> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('mark-all-notifications-as-read', {
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((res: any) => {
                return 0;
            }))
            .pipe(delay(200))
        //.pipe(catchError((error: any) => observableThrowError('Server error:noti' + error)));
    }

    public newMarkAllNotificationsAsRead(user): Observable<any> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('new-mark-all-notifications-as-read', {
        });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((res: any) => {
                return 0;
            }))
            .pipe(delay(200))
    }

    public markANotificationsAsRead(id, user): Observable<any> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('mark-a-notifications-as-read', {
            id,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((info: any) => {
                return info[0];
            }))
            .pipe(delay(200))
        // .pipe(catchError((error: any) => observableThrowError('Server error:noti' + error)));
    }

    public markANotificationsAsReadByMessageId(id, user): Observable<any> {
        if (!user) {
            return of([]);
        }
        const apiURL = this._apiUrlHelper.urlBuilder('mark-a-notifications-as-read-by-message-id', {
            id,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this
            ._httpClientHelper
            .get(apiURL)
            .pipe(map((res: Response) => {
                return res;
            })).pipe(
                delay(200));
    }

}
